import React, { PureComponent } from 'react'
import { string, number, bool, object, func, arrayOf, shape } from 'prop-types'
import { translate } from 'react-i18next'
import { Collapse } from 'reactstrap'
import { Icon, Text, SvgGrid, PreRacePerformanceLine } from 'components'
import { priceFormatted } from 'utils/string'
import { find, sortBy } from 'lodash'
// import { performanceVsDeterioration } from 'utils/chartFunctions'
import './PostRaceCard.css'

const svgViewBox = '0 0 195 67'
const viewBox = { x: 28, y: 0.5, width: 165, height: 54 }

@translate()
export class PostRaceCard extends PureComponent {
    static propTypes = {
        groupId: string.isRequired,
        icon: string.isRequired,
        name: string.isRequired,
        deterioration: number,
        bullets: arrayOf(string).isRequired,
        options: arrayOf(shape({
            typeId: string.isRequired,
            label: string.isRequired,
            price: number.isRequired
        })).isRequired,
        selection: string,
        availableCredits: number.isRequired,
        selected: bool.isRequired,
        onSelect: func.isRequired,
        onSetOption: func.isRequired,
        isAMToolActive: bool.isRequired,
        curveParams: object.isRequired,
        className: string,
    }

    static defaultProps = {
        availableCredits: 999999,
        selected: false,
        isAMToolActive: false
    }

    componentWillMount() {
        // this.data = [...range(0, 100, 10), 100].map(x => ({ x, y: performanceVsDeterioration(x) }))
        // setTimeout(() => {
        //     this.data = [...range(0, 100, 10), 100].map(x => ({ x, y: performanceVsDeterioration(x) / 2 }))
        //     this.forceUpdate()
        // }, 3000)
    }

    handleSelect = () => {
        const { groupId, options, onSelect, onSetOption } = this.props
        if (options.length === 0) {
            onSetOption({ error: 'ITEM_JUST_INFORMATIVE' })
        } else if (onSelect) {
            onSelect(groupId)
        }
    }

    handleSetOption = (typeId, price) => {
        const { groupId, options, selection, availableCredits, onSetOption } = this.props
        if (typeId !== selection) {
            const currentSelectedOption = find(options, o => o.typeId === selection)
            const currentSelectedPrice = currentSelectedOption ? currentSelectedOption.price : 0
            const deltaPrice = currentSelectedPrice - price
            if (onSetOption) {
                if (availableCredits + deltaPrice < 0) {
                    onSetOption({ error: 'CREDITS_EXCEED' })
                } else {
                    onSetOption({ groupId, typeId, deltaPrice })
                }
            }
        }
    }

    renderBullet = (bullet, index) => <li key={index}>{bullet}</li>

    renderAMToolPanel = () => {
        const { isAMToolActive, deterioration, curveParams, t } = this.props
        const { options, selection } = this.props
        const currentSelectedOption = find(options, o => o.typeId === selection)
        const healthIncrease = currentSelectedOption ? currentSelectedOption.healthIncrease / 100 : 0
        return (
            <div className="flex col-center h-100">
                <div className="flex col-stretch h-100">
                    <Text className="ChartLegend Y">{t('game.POST_RACE.panelLineChartYLabel')}</Text>
                    <svg viewBox={svgViewBox}>
                        <SvgGrid
                            viewBox={viewBox}
                            zeroLabel="0"
                            xLabel="100%"
                            yLabel="100%"
                            clipId="viewBoxClip"
                        />
                        <PreRacePerformanceLine
                            curveParams={curveParams}
                            outputViewBox={viewBox}
                            pointMarker={isAMToolActive ? deterioration : undefined}
                            dashLineMarker={isAMToolActive ? deterioration - healthIncrease : undefined}
                            clipPath="url(#viewBoxClip)"
                        />
                    </svg>
                    <Text className="ChartLegend X">{t('game.POST_RACE.panelLineChartXLabel')}</Text>
                </div>
            </div>
        )
    }

    renderOption = ({ typeId, label, healthIncrease, price }) => {
        const { options, selection, availableCredits } = this.props
        const currentSelectedOption = find(options, o => o.typeId === selection)
        const currentSelectedPrice = currentSelectedOption ? currentSelectedOption.price : 0
        const deltaPrice = currentSelectedPrice - price
        return (
            <div
                key={typeId}
                className={['PostRaceCard-Option flex row-stretch-center', { Selected: selection === typeId, Disabled: availableCredits + deltaPrice < 0 }]}
                onClick={() => this.handleSetOption(typeId, price)}
            >
                <Text>{label} (+{healthIncrease}%)</Text>
                <Text className="PostRaceCard-Option-Price">{priceFormatted(price)}</Text>
            </div>
        )
    }

    render() {
        const { groupId, icon, name, bullets, options, selected, selection, availableCredits, className, onSelect, onSetOption, isAMToolActive, curveParams, t, tReady, i18n, ...otherProps } = this.props
        const isSelectable = options.length > 0
        return (
            <div className="PostRaceCardWrapper">
                <div
                    className={['PostRaceCard flex row-stretch p-10p rounded shadow-hover', { NotSelectable: !isSelectable, Selected: selected }, className]}
                    onClick={this.handleSelect}
                    {...otherProps}
                >
                    <div className="PostRaceCard-Icon flex-self-stretch flex col-center pr-10p">
                        <Icon name={icon} />
                        <Text className="mt-10p">{name}</Text>
                    </div>
                    <div className="PostRaceCard-Body flex row-left-center py-5p px-10p">
                        <ul>
                            {bullets.map(this.renderBullet)}
                        </ul>
                    </div>
                    {isSelectable && (
                        <div className="PostRaceCard-Chart p-15p">
                            {this.renderAMToolPanel()}
                        </div>
                    )}
                </div>
                <Collapse className="PostRaceCard-Options" isOpen={isSelectable && selected}>
                    <Text className="mt-10p">{t('game.POST_RACE.choose')}</Text>
                    <div>{sortBy(options, ['healthIncrease']).map(this.renderOption)}</div>
                </Collapse>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Cards/PostRaceCard/PostRaceCard.js